<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <rule-list-table></rule-list-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import ruleListTable from './RuleListTable.vue'

  export default {
    name: 'rule-list',
    components: {ruleListTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/rulelist/RuleList.vue